var startLoading = function () {
    if ($("#loading-overlay").length == 0) {
        $("body").append("<div id='loading-overlay'><span><i class='fa fa-spinner fa-pulse fa-5x fa-fw'></i></span></div>");
    }
    $("#loading-overlay").show();
};

var stopLoading = function () {
    $("#loading-overlay").hide();
};